<template>
  <!-- MOBILE -->
  <div v-if="$mq === 'mobile'" class="wim-gallery-mobile" ref="carousel">
    <!-- images -->
    <div class="wim-gallery-slide" v-if="content.type === 'image'" v-for="element in content.content" :key="element.asset" >
      <img class="wim-gallery-image" :data-flickity-lazyload="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.asset}${$retina ? '@2x' : ''}.jpg`" :alt="element.asset">
      <div class="wim-gallery-dida">{{element.dida}}</div>
    </div>
    <!-- videos -->
    <div class="wim-gallery-slide wim-gallery-video" v-if="content.type === 'video'" v-for="element in content.content" :key="element.asset" >
      <video class="wim-gallery-image wim-lazy-video" 
        :poster="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.asset}${$retina ? '@2x' : ''}.jpg`" 
        controls
      >
        <source :data-src="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.asset}.mp4`">
      </video>
    </div>
  </div>
</template>

<script>
  import Flickity from "flickity-imagesloaded"
  import LazyLoad from 'vanilla-lazyload'

  export default {
    props: ["galleryId"],
    data() {
      return {
        baseUrl: process.env.BASE_URL,
        isFlickity: false,
        content: []
      };
    },
    beforeMount() {
      this.content = this.$ml.get('content').mobileGallery.filter(el => el.id === this.galleryId )[0];
    },

    mounted() {
      this.$nextTick(()=>{
        this.createFlickity();
        var myLazyLoad = new LazyLoad({
            elements_selector: ".wim-lazy-video"
        });

        window.addEventListener('resize', () => {
          this.createFlickity();
        })
      })
    },
    methods: {
      createFlickity(){
        var elem = this.$refs.carousel;

        if (elem && !this.isFlickity) {
          this.flkty = new Flickity(elem, {
            draggable: ">1",
            prevNextButtons: false,
            pageDots: true,
            imagesLoaded: true,
            lazyLoad: true,
            adaptiveHeight: false
          });
          this.isFlickity = true;

        } else if (!elem && this.isFlickity) {
          this.flkty.destroy();
          this.flkty = null;
          this.isFlickity = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/colors.scss";
  @import "../assets/scss/fonts.scss";

  .wim-gallery-mobile {
    width: 100%;
    position: relative;
    outline: none;
    margin-top: 20px;
    padding-bottom: 15px;
    .wim-gallery-slide {
      width: calc(100% - 30px);
      margin-right: 15px;
      &.wim-gallery-video {
        padding-bottom: 20px;
      }
      .wim-gallery-image {
        width: 100%;
      }
      .wim-gallery-dida {
        font-family: 'Montserrat', sans-serif;
        font-size : 12px;
        line-height : 17px;
        text-align:center;
        color: $black;
        padding: 10px 0;
      }
    }     
  }
</style>